//#region src/shared/password-manager-autofill.ts
var e = {
	autoComplete: "off",
	"data-1p-ignore": !0,
	"data-lpignore": "true",
	"data-form-type": "other"
};
function t(t) {
	let { allowPasswordManagerAutofill: n = !1, autoComplete: r, ...i } = t;
	return n ? {
		...i,
		...r === void 0 ? {} : { autoComplete: r }
	} : {
		...i,
		...e,
		autoComplete: r == null ? e.autoComplete : r
	};
}
//#endregion
export { e as PASSWORD_MANAGER_IGNORE_PROPS, t as applyPasswordManagerAutofillDefaults };
